
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'ldm-logo',
    imports: [],
    templateUrl: './logo.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./logo.component.scss']
})
export class LogoComponent {
  shouldBeExtended = input<boolean>(true);

  get logoExtended(): string {
    return 'assets/images/logo.svg';
  }

  get logoMini(): string {
    return 'assets/images/logoMini-01.svg';
  }
}
